import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectDetail, Projects } from '../../services/project.service/ProjectCover';
import { ActivatedRoute } from '@angular/router';
import {ProjectService} from '../../services/project.service/project.service'
import { AnalyticsService } from 'src/app/services/analytics.service/analytics.service';
@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.less']
})
export class ProjectsComponent {
  router:Router;
  projectCovers:ProjectDetail[];
  activatedRoute:ActivatedRoute;
  projectService:ProjectService;
  analyticsService:AnalyticsService

  constructor(router:Router,projectService:ProjectService, analyticsService:AnalyticsService) {
    this.router = router; 
    this.projectService = projectService;
    this.analyticsService = analyticsService;
    this.projectCovers = this.projectService.getAllProjects();
    this.projectService.setCurrentproject(this.projectCovers[0]);
  }

  


  showDetails(project:ProjectDetail){
    
    this.projectService.setCurrentproject(project);
    this.analyticsService.eventEmitter("show_projects", "projects", "click", project.id);
    this.router.navigateByUrl('project-details');
    
  }



}
